import Vue from 'vue'
export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./src/components/assets_operations/env_init/all_steps/event_bus/event-bus.js